import { createContext, useMemo } from "react"
import PropTypes from "prop-types"

/**
 * Context for column ordering functionality in Asset View
 *
 * This context provides column order state and change handlers to
 * descendant components without prop drilling through templates.
 *
 */
export const ColumnOrderContext = createContext(null)

/**
 * Provider component for column order context
 *
 * @param {Object} props
 * @param {string} props.columnOrder - Current column order mode
 * @param {Function} props.onColumnOrderChange - Function to handle column order changes
 * @param {React.ReactNode} props.children - Child components
 */
// TODO [APP-1950]: Can we move all column state management to this context?
export function ColumnOrderProvider({ columnOrder, onColumnOrderChange, children }) {
  const value = useMemo(() => ({
    columnOrder,
    onColumnOrderChange,
  }), [columnOrder, onColumnOrderChange])

  return (
    <ColumnOrderContext.Provider value={value}>
      {children}
    </ColumnOrderContext.Provider>
  )
}

ColumnOrderProvider.propTypes = {
  columnOrder: PropTypes.string.isRequired,
  onColumnOrderChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}
